import { render, staticRenderFns } from "./StudentCompetition.vue?vue&type=template&id=786d0dbf"
import script from "./StudentCompetition.vue?vue&type=script&lang=js"
export * from "./StudentCompetition.vue?vue&type=script&lang=js"
import style0 from "./StudentCompetition.vue?vue&type=style&index=0&id=786d0dbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports